import "./ui/styles.css";
import { App } from "./ui/app";
const root = document.querySelector<HTMLElement>("#app")!;
new App(root);
